import {t} from "./i18n.js";
export function printSurfaceLabel(p) {
  switch (p) {
    case "outside":
      return t("Außen");
    case "inside":
      return t("Innen");
    case "bottom":
      return t("Boden");
    case "lid":
      return t("Deckel");
  }
}
